export const CollectionPoint = {
  OPEN_APP: "open-app",
  PRIVACY_SETTING: "privacy-settings",
};
